import { Grid, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useQuery } from 'react-query';
import * as assetApi from '../../api/app/assetApi';
import { ApiError } from '../../components/core/ApiError/ApiError';
import { Loader } from '../../components/core/Loader/Loader';
import { SelectBoxAutocomplete } from '../../components/core/SelectBox/SelectBoxAutocomplete';
import { useTranslation } from '../../contexts/translation';
import { Asset } from '../../types/app/asset.types';
import { EmailReportAssetInputs } from '../../types/app/emailReportAsset.types';

interface Props {
  onSubmit: SubmitHandler<EmailReportAssetInputs>;
  defaultValues?: EmailReportAssetInputs;
  onBack: any;
  isReadOnly?: boolean;
}

export function EmailReportAssetForm({ onSubmit, defaultValues, onBack, isReadOnly }: Props) {
  const { t } = useTranslation();
  const {
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm<EmailReportAssetInputs>();

  const {
    data: assetList,
    isLoading: assetListIsLoading,
    isError: assetListIsError,
  } = useQuery<Asset[]>(['assets'], () => assetApi.getListWithDashboardsFiltered());

  useEffect(() => {
    reset({ ...defaultValues });
  }, [defaultValues, reset]);

  if (assetListIsError) return <ApiError />;
  if (assetListIsLoading || !assetList) return <Loader />;

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <SelectBoxAutocomplete
              isRequired
              label="Asset name"
              items={assetList}
              valueKey={'id'}
              labelKey={'name'}
              controllerProps={{
                name: 'assetId',
                control: control,
                defaultValue: defaultValues?.assetId,
              }}
              errors={errors}
              readOnly={isReadOnly}
            />
          </Grid>
          <Grid item>
            <Stack spacing={2} direction="row">
              <Button type="button" variant="outlined" onClick={onBack}>
                {t('general.action-buttons.back')}
              </Button>
              {!isReadOnly && (
                <Button type="submit" variant="contained" color="success">
                  {t('general.action-buttons.save')}
                </Button>
              )}
            </Stack>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
